<template>
  <div class="chang-password">
    <div class="v-tip font-size-12">
      {{ $t('personal.changPasswordTip') }}
    </div>
    <div class="v-form-box">
      <v-input
        :labelName="$t('current password')"
        v-model="currentPassword"
        type="password"
      ></v-input>
      <v-input :labelName="$t('newPassword')" v-model="newPassword" type="password"></v-input>
      <v-input
        :labelName="$t('inputAgain')"
        v-model="newPassword2"
        :placeholder="$t('newPasswordAgain')"
        type="password"
      ></v-input>
    </div>
    <div class="text-center">
        <el-button type="primary" :loading="loading" class="v-btn margin-t-24 dash-submit" @click="submit">{{ $t('submit') }}</el-button>
    </div>
  </div>
</template>
<script>
import vInput from '@/components/vInput'
import { changePassword } from '@/api/index'
export default {
  name: 'changePassword',
  components: {
    vInput
  },
  data() {
    return {
      loading: false,
      currentPassword: '',
      newPassword: '',
      newPassword2: ''
    }
  },
  methods: {
    submit() {
      let _this = this
      if (!_this.currentPassword) {
        _this.$notify.error({
          message: _this.$t('Please enter your current password')
        })
        return ''
      } else if (!_this.newPassword) {
        _this.$notify.error({
          message: _this.$t('Please enter your new password')
        })
        return ''
      } else if (!_this.newPassword2) {
        _this.$notify.error({
          message: _this.$t('Please enter your new password again')
        })
        return ''
      } else if (_this.newPassword2 != _this.newPassword) {
        _this.$notify.error({
          message: _this.$t('The two passwords you entered did not match')
        })
        return ''
      }
      this.loading = true
      changePassword({
        oldPassword: _this.$md5(_this.currentPassword),
        newPassword: _this.$md5(_this.newPassword)
      }).then(res => {
        if (res.data.code == '1000') {
          _this.$notify({
            title:_this.$t('tip.success'),
            message:res.data.message,
            type:'success'
          })
          Object.assign(this.$data, this.$options.data(this))
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.chang-password {
    margin: 0 auto;
    width: 64%;
    padding-bottom: 30px;
}

.v-tip{
    margin:30px 0;
    line-height: 16px;
}
.v-form-box{
    width:100%;
}
.v-btn{
    margin: 30px 0;
    width:544px;
}
</style>
